// Dot Digital Abandoned Cart AC integration
// Doc https://support.dotdigital.com/hc/en-gb/articles/216955438-Abandoned-cart-JSON-breakdown

import { createPathOrURLWithQueryParam } from '~/lib/util/page'

export function sendDotDigitalIdentifyEvent({ window, email }) {
  console.info(`sendDotDigitalIdentifyEvent email=${email}`)
  window?.dmPt && window.dmPt('identify', { email })
}

export function sendDotDigitalCartInsightEvent({ window, basket, cartPhase, AbandonedBasket }) {
  console.info(`sendDotDigitalCartInsightEvent cartPhase=${cartPhase} basket=`, basket)
  console.info(`sendDotDigitalCartInsightEvent AbandonedBasket=`, AbandonedBasket)
  console.info(`sendDotDigitalCartInsightEvent window.dmPt=`, window?.dmPt)
  basket && cartPhase && window?.dmPt && window.dmPt('cartInsight', createDotDigitalCartInsightPayload({ basket, cartPhase, AbandonedBasket }))
}

function createDotDigitalCartInsightPayload({ basket, cartPhase, AbandonedBasket }) {
  const items = []
  console.info(`createDotDigitalCartInsightPayload cartPhase=${cartPhase} basket=`, basket)
  let cartUrl = process.env.BASE_URL + `/checkout/cart`

  const itemsMap = new Map()

  if (basket?.items && basket?.items?.length >= 1) {
    basket.items.forEach(item => {
      const sku = item.offer.sku
      const isSpecial = ['GIFTCARD', 'EGIFTCARD', 'POCKETMAGSPLUS'].includes(item.type)

      if (isSpecial) {
        // Special items: always quantity 1, allow duplicates
        const data = buildDotDigitalPayload(item, 1, AbandonedBasket)
        items.push(data)
      } else if (itemsMap.has(sku)) {
        // Normal items: deduplicate and sum qty
        const existing = itemsMap.get(sku)
        existing.quantity += item.offer.qty || 1
        existing.totalPrice = item.offer.price * existing.quantity
      } else {
        // Clone item data with initial qty
        const data = buildDotDigitalPayload(item, item.offer.qty || 1, AbandonedBasket)
        itemsMap.set(sku, data)
      }
    })

    // Add deduplicated non-special items to the final array
    items.push(...itemsMap.values())

    cartUrl = process.env.BASE_URL + `/checkout/cart/${basket.id}/${basket?.items[0].offer.shortsite_code.toLowerCase()}`
  }

  // if (basket?.items && basket?.items?.length >= 1) {
  //   basket.items.forEach(item => {
  //     console.info('createDotDigitalCartInsightPayload item=', item)
  //     // GA4 Syntax attributes
  //     const data = {
  //       sku: item.offer.sku,
  //       name: item.title,
  //       description: item.offer.name,
  //       category: item.category,
  //       other: {
  //         paymentType: item.offer.payment_type === 'DD' ? 'Direct Debit' : 'Credit Card',
  //         // offerType: item.offer?.offer_type,
  //         // isSingleIssues: item.offer?.offer_type === '1 ISSUE' || false,
  //         showPromotionalCode: item.offer.payment_type !== 'DD' && item.offer?.offer_type !== '1 ISSUE',
  //         discountCode: AbandonedBasket?.code || '',
  //         discountCodeExpiryDate: AbandonedBasket?.expiry_date_formatted || '',
  //         numberOfIssues: item.offer.num_of_issues
  //       },
  //       unitPrice: item.offer.rrp,
  //       salePrice: item.offer.price,
  //       quantity: item.offer.qty,
  //       totalPrice: item.offer.price,
  //       imageUrl: process.env.IMAGES_URL + item.image_path,
  //       productUrl: process.env.BASE_URL + item.url_path
  //     }

  //     if (item.type === 'GIFTCARD') {
  //       data.imageUrl = process.env.IMAGES_URL + item.custom_fields.design.image
  //       data.productUrl = process.env.BASE_URL + '/magazines/gift-cards'
  //       data.description = `Gift Card - £${item.offer.price}`
  //     } else if (item.type === 'EGIFTCARD') {
  //       data.imageUrl = process.env.IMAGES_URL + item.custom_fields.design.image
  //       data.productUrl = process.env.BASE_URL + '/magazines/e-giftcards'
  //       data.description = `E-Gift Card - £${item.offer.price}`
  //     } else if (item.type === 'POCKETMAGSPLUS') {
  //       data.imageUrl = process.env.IMAGES_URL + item.custom_fields.design.image
  //       data.productUrl = process.env.BASE_URL + '/pocketmagsplus/image.png'
  //       data.description = `Pocketmags Plus+ - ${item.custom_fields.offer.label}`
  //     }
  //     items.push(data)
  //   })

  //   cartUrl = process.env.BASE_URL + `/checkout/cart/${basket.id}/${basket?.items[0].offer.shortsite_code.toLowerCase()}`
  // }

  if (basket?.minisite && basket?.minisite?.minisiteName && basket?.minisite?.headerPath) {
    cartUrl += `/minisite`
  }

  const payload = {
    programID: process.env.DOT_DIGITAL_PROGRAM_ID,
    cartDelay: parseInt(process.env.DOT_DIGITAL_CART_DELAY) || 15,
    cartID: basket.id,
    cartPhase,
    currency: 'GBP',
    subtotal: basket.totals.sub_total,
    shipping: basket.totals.postage,
    discountAmount: basket.totals.discount,
    taxAmount: 0,
    grandTotal: basket.totals.total,
    cartUrl: createPathOrURLWithQueryParam({ pathOrURL: cartUrl }),
    lineItems: items
  }

  console.log('createDotDigitalCartInsightPayload payload=', payload)

  return payload
}

function buildDotDigitalPayload(item, quantity, AbandonedBasket) {
  let data = {}
  try {
    data = {
      sku: item.offer.sku,
      name: item.title,
      description: item.offer?.title || item.offer.name,
      category: item.category,
      other: {
        paymentType: item.offer.payment_type === 'DD' ? 'Direct Debit' : 'Credit Card',
        showPromotionalCode: item.offer.payment_type !== 'DD' && item.offer?.offer_type !== '1 ISSUE',
        discountCode: AbandonedBasket?.code || '',
        discountCodeExpiryDate: AbandonedBasket?.expiry_date_formatted || '',
        numberOfIssues: item.offer.num_of_issues
      },
      unitPrice: item.offer.rrp,
      salePrice: item.offer.price,
      quantity,
      totalPrice: item.offer.price * quantity,
      imageUrl: process.env.IMAGES_URL + item.image_path,
      productUrl: process.env.BASE_URL + item.url_path
    }

    if (item.type === 'GIFTCARD') {
      data.name = 'Gift Cards'
      data.category = 'Gift Cards'
      data.imageUrl = process.env.IMAGES_URL + item.custom_fields.design.image
      data.productUrl = process.env.BASE_URL + '/magazines/gift-cards'
      data.description = `£${Number(item.offer.price).toFixed(2)} Gift Card`
    } else if (item.type === 'EGIFTCARD') {
      data.name = 'E-Gift Card'
      data.category = 'Gift Cards'
      data.imageUrl = process.env.IMAGES_URL + item.custom_fields.design.image
      data.productUrl = process.env.BASE_URL + '/magazines/e-giftcards'
      data.description = `£${Number(item.offer.price).toFixed(2)} E-Gift Card`
    } else if (item.type === 'POCKETMAGSPLUS') {
      data.name = 'Pocketmags Plus+ Subscription'
      data.category = 'Subscription'
      data.imageUrl = process.env.IMAGES_URL + '/pocketmagsplus/image.png'
      data.productUrl = process.env.BASE_URL + item.url_path
      data.description = item.custom_fields.offer.title
    }
  } catch (error) {
    console.error('buildDotDigitalPayload error=', error)
    console.error('buildDotDigitalPayload item=', item)
    console.error('buildDotDigitalPayload AbandonedBasket=', AbandonedBasket)
  }
  return data
}
